<script lang="ts">
/*
For being able to use a component for editing an attribute
*/
import Entry, { EntryDB } from '@/ts/DataTypes/Entry';
import { EntryAttributeDB } from '@/ts/DexieDB';
import { ModalInfo } from '@/ts/StaticVars';
import { defineComponent } from 'vue'
import Button from './Button.vue';
import InputTextSmart, { ObjectIn } from './InputTextSmart.vue';
export default defineComponent({
    async mounted() 
    {
        
        //store the current attribute to compare for change
        this.attr_original.Assign(this.attr);
        this.attr_new.Assign(this.attr);

        console.log("AttributeVue mounted, this attr: ", this.attr, "orig: ", this.attr_original);

        // console.log("attribute MOUNTED, prev attr: ",this.prev_attributes);
        this.CreatePrevAttributes();

        //add rating options to select
        let select = (this.$refs.rating as HTMLSelectElement);
        select.innerHTML="";

        //for text beside rating
                //    -1        0      1          2       3      4        5  
        let text= ["Rating", "Worst", "Bad", "Not good", "Ok", "Good", "Great"];
        for (let i = -1; i < 6; i++) 
        {
            const option = document.createElement("option");
            if(i==-1)
            {
                option.innerHTML=text[i+1];
                option.value=i.toString();
            }
            else
            {
                option.innerHTML=i.toString() +` - ${text[i+1]}`;
                option.value=i.toString();
            }

            select.appendChild(option);
            
        }
        


    },
    props: {
        text: { type: String, default: "" },
        //vue is passing it in as a generic object, even though it is an array of EntryAttributeDB, being passed in....
        // attr:{type:EntryAttributeDB, required:true},
        attr: { type: Object, required: true },

        //for getting previosu attributes, to generature auto complete
        prev_attributes: { type: Object, required: true },

        //for attributes to be able to confirm being deleted
        ShowModal:{ type:Function, default:()=>{console.log("it didn't pass ShowModal correctly");}},//have to give it a default value, or typescript thinks it could be undefined...
        entry:{ type: Entry, required: true }, // just for delete to have access to the entry name
        DeleteAttribute:{ type:Function, required:true},
        index:{ type:Number, required:true},

    },
    data() {
        return {
            text_d: "",
            icon: "",
            prev_attr_names: new Array<ObjectIn>,
            prev_attr_values: new Array<ObjectIn>,
            attr_original: new EntryAttributeDB(),
            attr_new: new EntryAttributeDB(),//- the one we'll update
        };
    },
    //computed- so we can pass variables into css without having to do javascript
    //from: https://stackoverflow.com/questions/42872002/in-vue-js-component-how-to-use-props-in-css
    computed: {},
    methods: {

        //for creating the arrays of previous attributes- name should be all names, values can be all values, but later on should be only same values for the name value (if known/ has an id)
        CreatePrevAttributes()
        {
            //should also get rid of duplicates

            let prev_atrr_names= new Array<ObjectIn>();
            let prev_atrr_values= new Array<ObjectIn>();
            for (let i = 0; i < this.prev_attributes.length; i++) 
            {
                const attr = this.prev_attributes[i];

                if(attr.name)
                {
                    //check for duplicates
                    let duplicate=false;
                    for (let j = 0; j < prev_atrr_names.length; j++) 
                    {
                        const name = prev_atrr_names[j].name;
                        if(name==attr.name)
                        {
                            duplicate=true;
                            break;
                        }
                        
                    }

                    if(!duplicate)
                        prev_atrr_names.push(new ObjectIn().Init(attr.id, attr.name, attr.date_updated));
                }
                
                if(attr.value)
                {
                    //check for duplicates
                    let duplicate=false;
                    for (let j = 0; j < prev_atrr_values.length; j++) 
                    {
                        const value = prev_atrr_values[j].name;
                        if(value==attr.value)
                        {
                            duplicate=true;
                            break;
                        }
                        
                    }

                    if(!duplicate)                    
                        prev_atrr_values.push(new ObjectIn().Init(attr.id, attr.value as string, attr.date_updated));
                }

            }
            // console.log("done setting up attributes, prev values: ", prev_atrr_values);
            this.prev_attr_names = [...prev_atrr_names];
            this.prev_attr_values = [...prev_atrr_values];
        },
        AttributeNameChanged(text: string) 
        {
            console.log(`AttributeNameChanged`, text)
            this.attr_new.name=text;
        },
        AttributeValueChanged(text: string) 
        {
            console.log(`AttributeValueChanged`, text)
            this.attr_new.value=text;
        },
        AttributeRatingChanged(event:any) 
        {
            console.log(`drop down changed`, event.target.value)
            this.attr_new.rating=(event.target.value);
        },

        //for getting the values
        GetName()
        {
            console.log("attribute GetName: name: ", (this.$refs.name as typeof InputTextSmart), "item selected: ", (this.$refs.name as typeof InputTextSmart).item_selected);
            return (this.$refs.name as typeof InputTextSmart).item_selected;
        },
        GetValue()
        {
            return (this.$refs.value as typeof InputTextSmart).item_selected;
        },
        GetRating()
        {
            // if(this.attr.rating!=-1)
            return (this.$refs.rating as HTMLSelectElement).value;
        },
        GetAttrNew()
        {
            return this.attr_new;
        },
        GetAttrOrig()
        {
            return this.attr_original;
        },

        //for when the delete button is clicked
        //popup the modal to confirm
        DeleteClicked()
        {
            console.log("delete clicked");
            // let modal_info = new ModalInfo();

            //from app, format: ShowModal(text:string, callback_yes?:Function, callback_no?:Function, text_input:boolean=false)
            // this.ShowModal(modal_info);

            //also add the name, value, and rating to the attribute
            this.attr.name=this.GetName().name;
            this.attr.value=this.GetValue().name;
            this.attr.rating=this.GetRating();

            let modal_info = new ModalInfo({text:"Are you sure you want to delete attribute '"+this.attr.name+"' for entry '"+this.entry.item_type+"'?",callback_yes:this.DeleteConfirmed})
            this.ShowModal(modal_info);

        },
        //actually delete the attribute
        DeleteConfirmed()
        {
            console.log("delete confirmed")
            //have to call the parent to delete this attribute
            this.DeleteAttribute(this);
        },
        Focus()
        {
            //used as an input field- so trying to keep syntax like default input fields
            (this.$refs.name as any).focus();
        },
        

    
    },
    watch: 
    {
        prev_attributes:function(prev_attributes_in) 
        {
            console.log("YO: watch prev_attributes_in start called", prev_attributes_in);
            // this.PreviousEntriesIn();
            this.CreatePrevAttributes();
        },
    },
    components: { InputTextSmart, Button }
});
</script>

<template>
    <div class="attribute" ref="attributes">
        <InputTextSmart ref="name" class="name" :default_value="attr.name" :show_submit_btn="false" placeholder="Name" :TextChanged="(text:string)=>{AttributeNameChanged(text)}"  :previous_entries_in="prev_attr_names"/>
        <InputTextSmart ref="value" :default_value="attr.value" :show_submit_btn="false" placeholder="Value" :TextChanged="(text:string)=>{AttributeValueChanged(text)}"  :previous_entries_in="prev_attr_values"/>
        <!-- <select ref="rating" v-if="attr.rating>-1"> -->
        <select ref="rating" :value="attr.rating" @change="AttributeRatingChanged">
            <option value="-1">rating</option>
            <option value="0">0</option>
            <option value="1">1</option>
            <option value="2">2</option>
        </select>
        <Button type="delete" color_bg="red" :callback="DeleteClicked"/>
        <!-- {{ attr.name }}: {{attr.value}}<span v-if="attr.rating>-1">; rating:  {{ attr.rating }}</span> -->
    </div>
</template>

<style scoped>
.attribute
{
    display:flex;
    align-items: flex-start;
    gap: 20px;
}
.attribute >*
{
    /* flex-grow: 1;
    flex-shrink: 1;
    flex-basis: auto; */
    /* flex: 2 1 33%; */
    width:calc((100% - 25%) / 2 - 50px);
}
.attribute >*:nth-child(3)
{
    width:36%;
    /* flex: 1 1 auto; */
}
.attribute >*:nth-child(4)
{
    /* width:25%; */
    width:.5in;
    margin:0;
    aspect-ratio: 1;
    /* flex: 1 1 auto; */
}
select
{
    padding:8px;
    cursor: pointer;
    font-size:24px;
    text-align: center;
}


</style>